import { jsx as _jsx } from "react/jsx-runtime";
import { createBrowserRouter, Navigate } from 'react-router-dom';
import { useEffect } from 'react';
import { DashboardLayout } from '@/components/layout/DashboardLayout';
import { LoginPage } from '@/pages/auth/LoginPage';
import { DashboardPage } from '@/pages/dashboard/DashboardPage';
import { GruposPage } from '@/pages/grupos/GruposPage';
import { GroupDetailPage } from '@/pages/grupos/GroupDetailPage';
import { PasajerosPage } from '@/pages/pasajeros/PasajerosPage';
import { TourscanPage } from '@/pages/tourscan/TourscanPage';
import { ReportesPage } from '@/pages/reportes/ReportesPage';
import { ConfiguracionPage } from '@/pages/configuracion/ConfiguracionPage';
import { NotificacionesPage } from '@/pages/notificaciones/NotificacionesPage';
import { UsuariosPage } from '@/pages/usuarios/UsuariosPage';
import { PlataformaPage } from '@/pages/admin/PlataformaPage';
import { PortalPage } from '@/pages/portal/PortalPage';
import { useAuthStore } from '@/store/auth.store';
import { useNavigate } from 'react-router-dom';
function IndexRedirect() {
    const { user } = useAuthStore();
    const navigate = useNavigate();
    useEffect(() => {
        if (user?.role === 'SUPER_ADMIN') {
            navigate('/plataforma', { replace: true });
        }
        else {
            navigate('/dashboard', { replace: true });
        }
    }, [user?.role]);
    return null;
}
export const router = createBrowserRouter([
    // Rutas públicas
    { path: '/login', element: _jsx(LoginPage, {}) },
    // Rutas del dashboard (autenticadas)
    {
        path: '/',
        element: _jsx(DashboardLayout, {}),
        children: [
            { index: true, element: _jsx(IndexRedirect, {}) },
            { path: 'dashboard', element: _jsx(DashboardPage, {}) },
            { path: 'grupos', element: _jsx(GruposPage, {}) },
            { path: 'grupos/nuevo', element: _jsx(GruposPage, {}) },
            { path: 'grupos/:id', element: _jsx(GroupDetailPage, {}) },
            { path: 'pasajeros', element: _jsx(PasajerosPage, {}) },
            { path: 'tourscan', element: _jsx(TourscanPage, {}) },
            { path: 'reportes', element: _jsx(ReportesPage, {}) },
            { path: 'configuracion', element: _jsx(ConfiguracionPage, {}) },
            { path: 'notificaciones', element: _jsx(NotificacionesPage, {}) },
            { path: 'usuarios', element: _jsx(UsuariosPage, {}) },
            { path: 'plataforma', element: _jsx(PlataformaPage, {}) },
        ],
    },
    // Passenger portal (public — no auth needed)
    { path: '/portal', element: _jsx(PortalPage, {}) },
    { path: '/portal/:tenantSlug', element: _jsx(PortalPage, {}) },
    // Fallback
    { path: '*', element: _jsx(Navigate, { to: "/", replace: true }) },
]);
//# sourceMappingURL=index.js.map